import { SettingsPopover } from "datastake-daf/dist/components";

export default function UserRolePopover({ t = (s) => s }) {
  return (
    <SettingsPopover>
      <h2>{t('User Role')}</h2>
      <div>
        <h3>{t('Project Management User')}</h3>
        <p>
          {t('Project management user can share information held by your organisation, or invite new sources.')}
        </p>
      </div>
      <div>
        <h3>{t('Data Management User')}</h3>
        <p>
          {t('Data management user can only compile information and visualise projects.')}
        </p>
      </div>
    </SettingsPopover>
  );
}
